import { css } from "lit";

/**
 * Global styles that apply to content slotted into worlds-layout
 * These styles should be included in pages that use worlds-layout
 */
export const globalStyles = css`
  /* Action Buttons Container - Common styling for all pages */
  [slot="action-buttons"] {
    display: flex;
    gap: var(--sds-size-space-300);
    align-items: center;
  }

  /* Secondary Content Styling - Common for all pages using secondary slot */
  .secondary-title {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
  }

  .secondary-description {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
  }

  .secondary-link {
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
  }

  .secondary-link:hover {
    opacity: 0.8;
  }

  /* Mobile Page Title Pattern - Common for pages that need mobile titles */
  .mobile-page-title {
    margin: 0 0 var(--sds-size-space-600) 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.2;
    letter-spacing: -0.4px;
    display: none;
  }

  /* Preview Button Responsive Pattern - Common for action buttons */
  .preview-icon {
    display: none;
  }

  .preview-text {
    display: inline;
  }

  /* Responsive Design for common elements */
  @media (max-width: 768px) {
    /* Show mobile page title on mobile */
    .mobile-page-title {
      display: block;
    }

    /* Preview button: show icon, hide text on mobile */
    .preview-icon {
      display: inline;
    }

    .preview-text {
      display: none;
    }
  }
`;
